const headers = {
  name: "General",
  navigate: {
    tabs: [
      {
        name: "Settings",
        path: "/app/settings",
      },
      {
        name: "Add",
        path: "",
      },
    ],
  },
};

export default headers;
